<div class="table-responsive">  
  <app-iff-shipment-summary class="ag-theme-alpine"
    [title]="'HHG Shipment Reports Master List'"
    [IFFShipmentPaginationResults$]="HHGShipmentPaginationResults$"
    [updateIFFShipmentDetailRequestFn]= "updateHHGIffShipmentDetailRequestFn" 
    [IFFShipmentDetailsColumnDefs]= "getHHGIffShipmentDetailsColumnDefs()"
    [IFFShipmentDetailResults$]="hhgIFFShipmentDetailResults$"
    (delinquencyReportSelected)="OnDelinquencyReportSelected()"
    (comprehensiveReportSelected)="OnComprehensiveReportSelected()">
  </app-iff-shipment-summary>
</div>
